(function () {
    'use strict'

    function setRemBase() {
        var config = {
            small: {
                baseSize: 16,
                designWidth: 1280
            },
            normal: {
                baseSize: 18.25,
                designWidth: 1460
            },
            maxWidth: 1920
        }

        var docEl = document.documentElement

        var clientWidth = Math.min(
            docEl.clientWidth || window.innerWidth || document.body.clientWidth,
            config.maxWidth
        )

        var currentConfig = clientWidth < 1560 ? config.small : config.normal

        var scale = clientWidth / currentConfig.designWidth
        var fontSize = Math.min(currentConfig.baseSize * scale, currentConfig.baseSize)

        docEl.style.fontSize = fontSize + 'px'
    }

    // 立即执行，不等 DOMContentLoaded
    setRemBase()

    // 监听窗口变化
    window.addEventListener('resize', function () {
        setRemBase()
    })
})()